/** Merge id-keyed lists, keeping the FIRST occurrence of each id.
 *
 * Callers pass the CURRENT page first and the progressive option pages after
 * it. Those are separate caches: when a refresh invalidates the shared query
 * key, one can already be serving refreshed rows while the other still holds
 * pages fetched before it. Keeping the LAST value let an older option row
 * replace the current one — and the editors read `display_name`, `mode`,
 * `provider_key` and `available` off these, so the stale copy reached the
 * screen as a wrong label or a wrongly-offered choice.
 *
 * First-wins makes the argument order the precedence order, which is what the
 * call sites already read as. */
export function mergeById<T extends { id: string }>(
  ...groups: readonly (readonly T[])[]
): T[] {
  const byId = new Map<string, T>();
  for (const item of groups.flat()) {
    if (!byId.has(item.id)) byId.set(item.id, item);
  }
  return Array.from(byId.values());
}
